
import data from '../assets/data/nav.json'
export const state = () => ({ data })
